import { AsyncStoreItem } from '@lib';
import { WarnInner } from 'src/sdk_checkin';

/**
 * CheckinPassengerInputResult model
 */
export interface CheckinPassengerInputResultModel {
  warnings?: WarnInner[];
}

/**
 *  model details
 */
export interface CheckinPassengerInputResultStateDetails extends AsyncStoreItem {}

/**
 * CheckinPassengerInputResult store state
 */
export interface CheckinPassengerInputResultState
  extends CheckinPassengerInputResultStateDetails,
    CheckinPassengerInputResultModel {}

/**
 * Name of the CheckinPassengerInputResult Store
 */
export const CHECKIN_PASSENGER_INPUT_RESULT_STORE_NAME = 'checkinPassengerInputResult';

/**
 * CheckinPassengerInputResult Store Interface
 */
export interface CheckinPassengerInputResultStore {
  /** CheckinPassengerInputResult state */
  [CHECKIN_PASSENGER_INPUT_RESULT_STORE_NAME]: CheckinPassengerInputResultState;
}
